<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
        class="card-header border-0"
        :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h5 class="mb-0 text-start" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h5>
        </div>
        <div class="col text-end">
          <base-button type="primary" class="btn-sm me-2" @click="resetData">{{ $t("Refresh") }}</base-button>
          <router-link class="btn btn-primary btn-sm fw-bold" :to="isService ? '/services/new' : '/shift-plans/new'">{{ $t("Add New") }}</router-link>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
          class="table align-items-center table-flush text-center"
          :class="type === 'dark' ? 'table-dark' : ''"
          :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
          tbody-classes="list"
          :data="tableData"
          :paginated="false"
          :loading="loading"
      >
        <template #columns>
          <th class="text-start">{{ $t("Name") }}</th>
          <th>{{ $t("Employee type") }}</th>
          <th v-if="!isService">{{ $t("Slots") }}</th>
          <th v-if="isService">{{ $t("Cost") }}</th>
          <th>{{ $t("Date Created") }}</th>
          <th></th>
        </template>

        <template #default="row">
          <th scope="row">
            <div class="media align-items-center text-start">
              <div class=" name mb-0 text-sm fw-bolder">
                {{ getTranslation(row.item.name, $store.state.locale) }}
              </div>
            </div>
          </th>
          <td class="budget text-start">
            {{ $t(row.item.employeeType) }}
          </td>
<!--          <td class="budget text-start" style="text-overflow: ellipsis;overflow: hidden;max-width: 300px;">-->
<!--            {{ row.item.description.en }}-->
<!--          </td>-->
          <td v-if="!isService" class="budget">
            <template v-if="row.item.type === 'shift'">
              <ul>
                <li v-for="slot in row.item.timeSlots" :key="slot" class="text-decoration-none">
                  {{ slot.startTime }}-{{ slot.endTime }} ({{ getDuration($moment(slot.startTime, "HH:mm"), $moment(slot.endTime, "HH:mm")) }}) - {{ slot.priceInCents/100+'€' }}
                </li>
              </ul>
            </template>
          </td>
          <td v-if="isService" class="budget">
            {{ row.item.priceInCents === 0 ? '-' : row.item.priceInCents/100+'€' }}
          </td>
          <td>
            <div class="">
              <!--              <span class="completion mr-2">{{ row.item.completion }}%</span>-->
              <!--              <div>-->
              <!--                <base-progress-->
              <!--                  :type="row.item.statusType"-->
              <!--                  :show-percentage="false"-->
              <!--                  class="pt-0"-->
              <!--                  :value="row.item.completion"-->
              <!--                />-->
              <!--              </div>-->
              <div class="name mb-0 text-md-left">{{ row.item.createdAt }}</div>
            </div>
          </td>

          <td class="text-end">
            <router-link class="btn bg-gradient-green border-0 me-2 text-white" :to="(isService ? '/services/' : '/shift-plans/') + row.item.id + '/edit'">{{ $t("Edit") }}</router-link>

            <base-button
                type="success"
                class="bg-red border-0"
                size="md"
                @click="deleteService(row.item.id)"
            >
              {{ $t("Delete") }}
            </base-button>
          </td>
        </template>
      </base-table>
    </div>

    <!--    <div-->
    <!--      class="card-footer d-flex justify-content-end"-->
    <!--      :class="type === 'dark' ? 'bg-transparent' : ''"-->
    <!--    >-->
    <!--      <base-pagination total="30"></base-pagination>-->
    <!--    </div>-->
  </div>
</template>
<script>
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import BaseButton from "@/components/BaseButton"
import {getDuration, getTranslation} from "@/helpers/common"
import BaseTable from "@/components/BaseTable.vue"

export default {
  name: "services-table",
  components: {BaseTable, BaseButton},
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      loading: true,
      tableData: [],
    }
  },
  computed: {
    isService() {
      console.log("this.$route.name", this.$route.name)
      return  ["serviceList", "editServiceRecord", "newService"].includes(this.$route.name)
    },
  },
  async mounted() {
    await this.getServices()
  },
  methods: {
    getTranslation,
    getDuration,
    deleteService(id){
      this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          FirebaseFunctionsHelper.callFunction("service-remove",
              {id: id}
          )
              .then((result) => {
                console.log("res", result)
                // eslint-disable-next-line no-prototype-builtins
                if (result != null && result.hasOwnProperty("message")) {
                  console.log("resmessage", result.message)
                  this.loadingProcess = "failed"
                  this.errorMessage = result.message
                  this.$swal.fire({
                    icon: "error",
                    html: result.message,
                    title: "Something went wrong!",
                  })
                  return
                }

                this.$swal.fire({
                  title: this.$t("Deleted!"),
                  html: this.$t("Service has been deleted."),
                  icon:"success",
                  timer: 1500,
                  timerProgressBar: true
                })

              }, this)
              .catch((error) => {
                console.error("submitUser error", error)
                this.$swal.fire({
                  icon: "error",
                  html: result.message,
                  title: this.$t("Something went wrong!"),
                })
              })

        }
      })
    },
    resetData() {
      this.tableData = []
      this.getServices(false, true)
    },
    async getServices(loadMore = false, reset = false) {
      // if (
      //   this.$store.state.system.companies.length > 0 &&
      //   this.$store.getters.isCacheExpired
      // ) {
      //   this.tableData = this.$store.state.system.companies
      //   return
      // }
      this.loading = true
      await this.$store.dispatch("fetchAllServices", {type: this.isService ? "service" : "shift"}).then((data) => {
        this.tableData = data
        console.log("tableDate", this.tableData)
        this.loading = false
      })
    },
  },
}
</script>
<style></style>
